import { REPORTS_BY_PATIENT } from 'resources/ApiUrls';
import MyAxiosInstance from 'utils/MyAxiosInstance';

const getAllByPatient = (patientId) => MyAxiosInstance.get(REPORTS_BY_PATIENT(patientId));

const reportsConst = { getAllByPatient };

export default reportsConst;
